export * from './ScoreComparison';


// WEBPACK FOOTER //
// ./src/components/reports/scoreComparison/index.tsx